var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"weebly-iframe"},[_c('iframe',{ref:"contentFrame",class:{
			hidden: _vm.hideIFrame
		},on:{"load":_vm.onLoad}}),_vm._v(" "),(_vm.loading)?_c('load-mask'):(_vm.showPaywall)?_c('paywall'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }